import React, { useMemo } from 'react';
import { Colors, Flex, Typography, useScreenSize } from '@banhala/ui-kit';
import { useGoodsDetail } from '../../queries/useGoodsDetail';
import {
  type GoodsDetailTab,
  GoodsDetailTabName,
} from '../../types/GoodsDetailTab';
import Animated, {
  interpolate,
  type SharedValue,
  useAnimatedStyle,
  withTiming,
} from 'react-native-reanimated';
import { isIOS } from 'shared/src/utils';

export const ContentTab: React.FC<{
  tab: GoodsDetailTab;
  onChangeTab: (nextTab: GoodsDetailTab) => void;
  tabScrollX: SharedValue<number>;
}> = props => {
  const { data: goodsDetail } = useGoodsDetail();
  const { width: screenWidth } = useScreenSize();
  const { tabScrollX } = props;

  const tabList = useMemo<{ name: string; tab_type: GoodsDetailTab }[]>(() => {
    if (!goodsDetail) {
      //dummy data
      return [
        { name: '상품정보', tab_type: 'INFORMATION' },
        { name: '리뷰', tab_type: 'REVIEW' },
      ];
    }
    return [
      { name: '상품정보', tab_type: 'INFORMATION' },
      ...(goodsDetail.tabs.map(tab => ({
        name: tab.name,
        tab_type: tab.tab_type as GoodsDetailTab,
      })) ?? []),
    ];
  }, [goodsDetail]);

  const tabWidth = useMemo(() => {
    return screenWidth / tabList.length;
  }, [screenWidth, tabList.length]);

  const bottomBarAnimStyle = useAnimatedStyle(() => {
    return {
      width: tabWidth,
      height: 2,
      backgroundColor: Colors.border_black_primary,
      position: 'absolute',
      bottom: 0,
      left: interpolate(
        tabScrollX.value,
        Array.from({ length: tabList.length }).map((_, i) => i),
        Array.from({ length: tabList.length }).map((_, i) => i * tabWidth),
      ),
    };
  });

  return (
    <Flex.Row position={'relative'} backgroundColor={'white'}>
      {tabList.map((item, index) => (
        <Flex
          key={item.tab_type}
          flex={1}
          alignItems={'center'}
          justifyContent={'center'}
          padding={{ vertical: 13 }}
          onPress={() => {
            props.onChangeTab(item.tab_type);

            if (isIOS) {
              //ios의 경우 하단 탭 indicator의 이동을 직접 제어함.
              tabScrollX.value = withTiming(index, { duration: 200 });
            }
          }}
          testID={`${GoodsDetailTabName[item.tab_type]}탭`}
        >
          <Typography
            type={props.tab === item.tab_type ? 'subtitle2' : 'body2'}
            color={
              props.tab === item.tab_type
                ? 'content_primary'
                : 'content_secondary'
            }
          >
            {item.name}
          </Typography>
        </Flex>
      ))}
      <Flex
        width={screenWidth}
        borderWidth={0.5}
        borderColor={'border_tertiary'}
        position={'absolute'}
        bottom={0}
      />
      <Animated.View style={bottomBarAnimStyle} />
    </Flex.Row>
  );
};
